export interface ListingItem {
  id: string;
  title: string;
  price: string;
  currency?: string | null;
  // ADR_LISTING_SHIP_FROM_ADDRESS Phase 2: not consumed by SimpleListingCard.
  // Optional so producers that no longer carry free-text `location` still fit.
  location?: string;
  image_urls: string[];
  description: string;
  condition: string;
  grade: string;
  created_at: string;
  username: string;
  avatar_url: string | null;
}

type SearchSimpleListingOverrides = Partial<{
  interactive: boolean;
  disableHoverOverlay: boolean;
  onClick: () => void;
  scheduledPublishAt: string | null;
}>;

export function toSearchSimpleListingCardProps(
  item: ListingItem,
  overrides?: SearchSimpleListingOverrides,
) {
  return {
    listingId: item.id,
    title: item.title,
    price: item.price,
    currency: item.currency ?? null,
    location: item.location,
    image_urls: item.image_urls,
    description: item.description,
    condition: item.condition,
    grade: item.grade,
    created_at: item.created_at,
    username: item.username,
    avatar_url: item.avatar_url,
    ...overrides,
  };
}
